module.exports = __webpack_public_path__ + "static/media/ios-moon.da5273cb.svg";